import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EditorState } from 'draft-js';
import { useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ReactQuill, { UnprivilegedEditor} from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './UniEditor.scss';

type EditorProps = {
    label: string,
    showPreview?: boolean,
    disabled?: boolean,
    defaultValue?: string,
    value: string,
    previewCallback?: () => void;
    onChange: (value: string, delta: any, source: any, editor: UnprivilegedEditor) => void
};

const UniEditor = ({label, showPreview, disabled, onChange, defaultValue, value, previewCallback} : EditorProps) => {
    const modules = {
        toolbar: [
            [{ 'font': [] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', {'color': []}],
            [{'align': []}],
            [`link`],
            // ['image'],
            ['clean']
        ],
        clipboard: {
            matchVisual: false,
        }
    };

    return (
        <>
            {/* <Editor 
                editorState={content}
                onEditorStateChange={onContentStateChange}
                toolbar={{
                    options: ['inline', 'blockType', 'fontSize', 'textAlign', 'colorPicker', 'link', 'image', 'history'],
                    inline: {
                        inDropdown: true,
                        options: ['bold', 'italic', 'underline', 'strikethrough'],
                    },
                    blockType: {
                        inDropdown: true,
                        options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'Blockquote'],
                    },
                    fontSize: {
                        options: [10, 11, 12, 14, 16, 18, 24, 30, 36, 48],
                    },
                    textAlign: {
                        inDropdown: true,
                        options: ['left', 'center', 'right', 'justify'],
                    },
                    link: {
                        inDropdown: false,
                        showOpenOptionOnHover: true,
                        options: ['link'],
                    },
                    colorPicker: {
                        colors: ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
                            'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
                            'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
                            'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
                            'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
                            'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)'],
                    },
                    image: {
                        urlEnabled: true,
                        uploadEnabled: true,
                        alignmentEnabled: true,
                        previewImage: true,
                        inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                      }
                }}
            /> */}
            <label className='d-flex justify-content-between lbl-editor'>
                {label}
                {
                    showPreview && (
                    <button onClick={previewCallback}>
                        Preview <FontAwesomeIcon icon={faEye} title='Preview'/>
                    </button>
                    )
                }
            </label>
            <ReactQuill 
                theme="snow" 
                value={value}
                defaultValue={defaultValue} 
                onChange={(v, d, s, e) => onChange(v, d, s, e)}
                modules={modules} 
                readOnly={disabled}
            />
        </>
    )
}

export default UniEditor;